import { useModalStore } from '@/features/overlays/modals/modalStore';
import { defineStore } from 'pinia';
import { ref, computed } from 'vue';

export const useMediaStore = defineStore('media', () => {
  const section = ref('avatar');
  const isOpen = computed({
    get: () => useModalStore()['media'].visible,
    set: () => {
      return;
    },
  });

  const showOnlyAvatarModal = ref<boolean>();

  function openModal(__section?: string) {
    if (__section) section.value = __section;
    useModalStore().toggle('media');
  }

  function closeModal() {
    useModalStore().toggle('media');
    resetSection();
  }

  function resetSection() {
    // timeout to wait for modal to close
    setTimeout(() => {
      section.value = 'avatar';
    }, 200);
  }

  return {
    section,
    isOpen,
    openModal,
    closeModal,
    resetSection,
    showOnlyAvatarModal,
  };
});
